export default {
    overflow: 'auto',
};
